import React from "react";
import "../../styles/Footer.css";
import Instagram from "../../assets/img/Instagram.webp";
import { TelephoneInboundFill, EnvelopeFill } from "react-bootstrap-icons";
import Icon2 from "../../assets/img/icon.png";
import Icon from "../../assets/img/Logo.png";
import { useNavigate } from "react-router-dom";

export const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();
  const navigate = useNavigate();

  return (
    <footer id="contacto">
      <hr className="hr-white" />
      <section className="footer-top-wrapper">
        <img src={Icon} className="me-5 d-none d-md-flex" alt="IconImage" />
        <section className="footer-top d-grid d-md-flex d-lg-flex">
          <button
            className="btn-cta mb-2 justify-content-center me-3 w-100c"
            onClick={() => {
              navigate("/login");
            }}
          >
            Haz tu pedido
          </button>

          <a
            className="container ms-4"
            href="https://www.instagram.com/billybrowns_/"
          >
            <img src={Instagram} alt="Social Icon" />
          </a>
        </section>
        <section>
          <menu className="menu-footer">
            <p>
              {" "}
              <TelephoneInboundFill /> +54 3572614272
            </p>
          </menu>
        </section>
      </section>
      
      <section className="footer-bottom">
        <small>
          &copy; {year}
          <img src={Icon} alt="footer-bottom" /> Billy Browns | Powered by
          <a href="https://twinexa.com/" target="_blank" rel="noopener noreferrer">
            <img src={Icon2} href="metacode.com.ar" alt="Powered" />
            <strong className="ms-1">Twinexa</strong>
          </a>
        </small>
      </section>
    </footer>
  );
};

export default Footer;
